import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';

export function* updateCardColor() {
  try {
    const res = yield call(api, {
      method: 'put',
      url: URL.CARD_COLOR,
    });
    yield put({ type: 'UPDATE_CARD_COLOR_SUCCESS', payload: res.data });
    yield put({ type: 'GET_CARD_COLOR' });
  } catch (e) {
    yield put({ type: 'UPDATE_CARD_COLOR_ERROR' });
    yield call(toast.error, e.message);
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.UPDATE_CARD_COLOR, updateCardColor);
}
